import React from 'react';
import { inject, observer } from 'mobx-react';
import { Route, Redirect, withRouter } from 'react-router-dom';
import { isValidElementType } from 'react-is';
import { getItem, KEYS } from '@app/cache';
import routes from '@routes';

const AuthRoute = inject('authStore')(
  observer(
    ({
      authStore: { isAuthenticated },
      component: RouteComponent,
      ...routeProps
    }) => {
      const isAuth = isAuthenticated || !!getItem(KEYS.AUTH_TOKEN);

      return (
        <Route
          {...routeProps}
          render={props =>
            isAuth ? (
              <Redirect to={routes.labels} />
            ) : (
              <RouteComponent {...props} />
            )
          }
        />
      );
    },
  ),
);

AuthRoute.propTypes = {
  // eslint-disable-next-line
  component: (props, propName) => {
    if (props[propName] && !isValidElementType(props[propName])) {
      return new Error(
        `Invalid prop 'component' supplied to 'Route': the prop is not a valid React component`,
      );
    }
  },
};

export default withRouter(AuthRoute);
